import './loading.css';

function Loading() {
  return (
    <div id="overlay">
      <div id="spinner" />
    </div>
  );
}

export default Loading;